// Store/CENProductFamilies/CENProductFamiliesReducer.ts
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import { BrandProductFamiliesState } from "./CENProductFamiliesState";
import { BrandProductFamily } from "@tCentro/Services/CENBrandDetailsProductFamilesService";

const initialState: BrandProductFamiliesState = { byBrandId: {} };

const reducer = {
    "Data/BrandProductFamilies/BeginLoad": (draft: BrandProductFamiliesState, action: { brandId: string }) => {
        draft.byBrandId[action.brandId] = { ...draft.byBrandId[action.brandId], isLoading: true };
    },
    "Data/BrandProductFamilies/Loaded": (
        draft: BrandProductFamiliesState,
        action: { brandId: string; families: BrandProductFamily[] },
    ) => {
        draft.byBrandId[action.brandId] = { isLoading: false, families: action.families };
    },
    "Data/BrandProductFamilies/Failed": (draft: BrandProductFamiliesState, action: { brandId: string }) => {
        draft.byBrandId[action.brandId] = { isLoading: false, families: [] };
    },
};

export default createTypedReducerWithImmer(initialState, reducer);